export default "__VITE_ASSET__C6AV5c1K__"